import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=0c5972ae&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=0c5972ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5972ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5972ae')) {
      api.createRecord('0c5972ae', component.options)
    } else {
      api.reload('0c5972ae', component.options)
    }
    module.hot.accept("./addGoods.vue?vue&type=template&id=0c5972ae&scoped=true", function () {
      api.rerender('0c5972ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/publish/addGoods.vue"
export default component.exports